import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { DestygoWebChatService } from '@api-ui-app/src/app/app-store/services/destygo-web-chat.service';
import { AuthService } from '@gelato-api-ui/core/auth/auth.service';
import { UserActionAvailabilityService } from '@gelato-api-ui/core/auth/user-action-availability.service';

@Injectable({ providedIn: 'root' })
export class ActivationGuard implements CanActivate {
  constructor(
    private auth: AuthService,
    private actionAvailabilityService: UserActionAvailabilityService,
    private router: Router,
    private destygoWebChatService: DestygoWebChatService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.auth.isAuthorised().pipe(
      switchMap(authorised => {
        if (!authorised) {
          if (route.queryParams['from-landing']) {
            this.auth.redirectToSignUp();
          } else {
            this.destygoWebChatService.resetChat();
            this.auth.redirectToSignIn();
          }
        }
        return this.actionAvailabilityService.routeCanActivate(route, state.url).pipe(
          map(result => {
            return (
              result.canActivate ||
              (result.redirect ? this.router.createUrlTree(result.redirect.fragments, result.redirect.params) : false)
            );
          }),
        );
      }),
    );
  }
}
